import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { MedicoService } from 'src/app/services/medico.service';
import { CanjeMedico, SolicitudCanjeMedico } from 'src/app/models/redimir.interface';
import { AuthService } from 'src/app/services/auth.service';
import { Medico } from 'src/app/models/medico.interface';
import { Producto } from 'src/app/models/producto.interface';
@Component({
  selector: 'app-medico-canje',
  templateUrl: './medico-canje.component.html',
  styleUrls: ['./medico-canje.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class MedicoCanjeComponent {
  canjeForm!: FormGroup;
  idMedico!: number;
  productosCanjear: Producto[] = [];
  selectedProductos: Producto[] = [];
  fechaMaxCanjeHoy = new Date();

  get cantidad(): number {
    const saldo: number = this.productosCanjear.reduce((valor, producto) => (producto.m_puntos ? producto.m_puntos : 0) + valor, 0);
    return saldo;
  }
  get cantidadSolicitar(): number {
    const saldo: number = this.selectedProductos.reduce((valor, producto) => (producto.m_puntos ? producto.m_puntos : 0) + valor, 0);
    return saldo;
  }

  constructor(
    private authService: AuthService,
    private fb: FormBuilder,
    private messageService: MessageService,
    private medicoService: MedicoService,
    private confirmationService: ConfirmationService
  ) {
    this.canjeForm = this.crearFormulario();
    this.idMedico = this.authService.getUsuario?.medico?.id ? this.authService.getUsuario?.medico?.id : 0;
    this.obtenerInformacion(this.idMedico);
  }

  crearFormulario(): FormGroup {
    return this.fb.group({
      fechaInicio: ['', Validators.required],
      concepto: [''],
      descripcion: ['']
    });
  }

  obtenerInformacion(id: number): void {
    this.medicoService.getMedicoPreSolicitud(id).subscribe({
      next: (resp) => { this.solicitudCanjeInicio(resp.datos); },
      error: (err) => console.log(err)
    });
  }

  solicitudCanjeInicio(medico: Medico): void {
    this.productosCanjear = medico.productos;//.filter(producto => producto.status_canje === 0 || producto.status_canje === 1 || producto.status_canje === 2);
  }

  onSubmit(): void {
    const fecha = new DatePipe("es-mx");
    const { fechaInicio, descripcion } = this.canjeForm.value;
    const redimir = this.cantidadSolicitar;
    const idsProductos: number[] = this.selectedProductos.map((item) => item.id);
    const fecInicio = <string>fecha.transform(fechaInicio, 'yyyy-MM-dd')?.toString();

    const canje = <CanjeMedico>{ redimir, fechaInicio: fecInicio, concepto: 1, descripcion, status: 1, fk_medico: this.idMedico };

    const solicitudCanjeMedico = <SolicitudCanjeMedico>{ canje, productos: idsProductos };

    if (this.idMedico != 0) {
      if (this.selectedProductos.length === 0) {
        this.showError("Selecciona al menos un producto para solicitar el canje");
        return;
      }

      this.confirmationService.confirm({
        message: 'No. Productos seleccionados : ' + this.selectedProductos.length + ' y cantidad a solicitar: ' + this.cantidadSolicitar + ' puntos. ¿Deseas continuar con la solicitud de canje?',
        header: 'Confirmacion',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.medicoService.setSolicitudCanje(solicitudCanjeMedico)
            .subscribe({
              next: (resp) => { this.showSuccess(resp.mensaje); },
              error: (err: HttpErrorResponse) => { this.showError(err.error.message); console.log(err) }
            });
        }
      });
    }
  }

  showSuccess(mensaje: string): void {
    this.messageService.add({
      severity: 'success',
      summary: 'Éxito',
      detail: mensaje
    });
  }

  showError(mensaje: string): void {
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: mensaje
    });
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
    });
  }

  get f() {
    return this.canjeForm.controls;
  }


}
